<div class="item-container">
  <div class="item-label">
    @if (userDefinedField.description != null) {
      <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="sysText.moreInformation_ariaLabel"
        [matTooltip]="userDefinedField.description"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">{{userDefinedField.icon ?? "info_outline"}}</mat-icon>
      </button>
    }
    <p class="body2 grey2">{{userDefinedField.name}}</p>
  </div>
  <div class="item-content">
    @if (userDefinedField.dataType === dataType.Decimal) {
      <p class="body2 grey1 semibold">{{userDefinedField.decimalVal ?? "--"}}</p>
    } @else if (userDefinedField.dataType === dataType.String || userDefinedField.dataType === dataType.LongString) {
      <p class="body2 grey1 semibold">{{userDefinedField.stringVal ?? "--"}}</p>
    } @else if (userDefinedField.dataType === dataType.Date) {
      <p class="body2 grey1 semibold">{{(userDefinedField.dateVal | date) ?? "--"}}</p>
    } @else if (userDefinedField.dataType === dataType.DateTime) {
      <p class="body2 grey1 semibold">{{(userDefinedField.dateTimeVal | date: 'MMM d, y h:mm a') ?? "--"}}</p>
    }
  </div>
</div>